module.exports = __webpack_public_path__ + "img/Credit card Icon - charcoal.ddcc8d45.svg";